// Why a rule matched nothing. The sampled events either had nothing in the
// field the rule reads, or had it and none matched — opposite fixes for the
// author, so the card names which one it is rather than only scoring zero.

const FIELD_WORD: Record<string, string> = {
  tags: 'tags',
  subject: 'a subject',
  source_client: 'a client',
  item_type: 'a type',
};

export function zeroHitReason(field: string, sampleSize: number, fieldPresent: number): string {
  const word = FIELD_WORD[field] ?? 'that field';
  return fieldPresent === 0
    ? `None of the ${sampleSize} have ${word}`
    : `${fieldPresent} have ${word}, none match`;
}
